import React from "react";
import "./HomePage.css";
import Bluearrow from "../assests/blueArrow.png";

function SpecialGuests({ data, setGuestPopup, setGuestDetails }) {
  const handleClickPromoter = (obj) => {
    setGuestDetails(obj);
    setGuestPopup(true);
  };
  return (
    <div className={`z-10  pt-[30px] mb-[32px] relative w-[100%] `}>
      <div className="flex items-center justify-between">
        <p className="text-large-medium">Special Guests</p>
      </div>
      <div className="mt-[12px] grid grid-cols-3 gap-x-[5px] gap-y-[12px]">
        {data?.map((obj, i) => {
          return (
            <div
              className="cursor-pointer flex flex-col items-center w-auto"
              onClick={() => handleClickPromoter(obj)}
            >
              <img
                className="rounded-full w-[80px] h-[80px] object-cover judgesBg"
                src={obj?.dop}
                alt=""
              />
              <p className="judgesName">{obj?.promotorName}</p>
              <p className="judjesDes">{obj?.position}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SpecialGuests;
